// extracted by mini-css-extract-plugin
export default {"container":"j0-z","list":"k0-z"};